/**
 * Maps brick IDs to their corresponding .glb model file paths
 * Used by GlobalCanvasManager to load models without creating React components
 */

export const brickModelPaths: Record<string, string> = {
  // Default (fallback to brick 1x1 if model not found)
  "0": "/assets/brick_1x1.glb",

  // Bricks
  "3005": "/assets/brick_1x1.glb",
  "3004": "/assets/brick_1x2.glb",
  "3010": "/assets/brick_1x4.glb",
  "3003": "/assets/brick_2x2_3003.glb",
  "3001": "/assets/brick_4x2_3001.glb",

  // Plates
  "3024": "/assets/plate_1x1.glb",
  "3023": "/assets/plate_1x2.glb",
  "3710": "/assets/plate_1x4_3710.glb",
  "3022": "/assets/plate_2x2_3022.glb",
  "3020": "/assets/plate_2x4_3020.glb",

  // Slopes
  "54200": "/assets/slope_1x1_54200.glb",
  "3040": "/assets/slope_2x1_3040.glb",
  "4286": "/assets/slope_3x1_4286.glb",
  "60477": "/assets/slope_4x1_60477.glb",
  "3039": "/assets/slope_2x2_3039.glb",
  "30363": "/assets/slope_4x2_30363.glb",
  "3660": "/assets/inverted_slope_2x2_3660.glb",
  "2752": "/assets/inverted_slope_3x2_2752.glb",
  "30390": "/assets/inverted_slope_4x2_double_pins_30390.glb",
  "6091": "/assets/curved_slope_2x1_6091.glb",

  // Minifig Utensils
  "4349": "/assets/megaphone.glb",
  "30162": "/assets/binoculars_30162.glb",
  "30228": "/assets/jackhammer.glb",
  "6246a": "/assets/chisel.glb",
  "30148": "/assets/movie_camera.glb",
  "93106": "/assets/metal_detector.glb",
  "4449": "/assets/suitcase.glb",
  "30304": "/assets/binoculars_30162.glb",
  "3962a": "/assets/walkie_talkie.glb",
  "3835": "/assets/mini_axe.glb",
  "30173": "/assets/katana_30173.glb",
  "76764": "/assets/shortsword_76764.glb",
  "64644": "/assets/telescope_64644.glb",
  "6246f": "/assets/oil_can_6246f.glb",
  "55297": "/assets/drill_55297.glb",
  "36752a": "/assets/wand_36752a.glb",
  "30229": "/assets/pulley_wheel_30229.glb",
  "30194": "/assets/circular_saw_30194.glb",
  "64567": "/assets/saber_hilt_64567.glb",
  "30035": "/assets/space_scanner_30035.glb",
  "6246g": "/assets/camera.glb",

  // Bionicle Pieces
  "54271": "/assets/bionicle_sphere_holder_54271.glb",
  "42042": "/assets/bionicle_krana_holder_42042.glb",
  "32553": "/assets/bionicle_head_32553.glb",
  "47298": "/assets/bionicle_toa_metru_foot_47298.glb",
  "41671": "/assets/bionicle_bohrok_windscreen_41671.glb",
  "43558": "/assets/bionicle_toa_nuva_chest_armor_43558.glb",
  "32506": "/assets/bionicle_claw_32506.glb",
  "42760": "/assets/bionicle_ball_joint_41760.glb",
  "42074": "/assets/bionicle_axle_tooth_42074.glb",
  x346: "/assets/bionicle_tooth_x346.glb",

  // Bionicle Masks
  "32567": "/assets/bionicle_ruru_mask_32567.glb",
  "32574": "/assets/bionicle_rau_mask_32574.glb",
  "32570": "/assets/bionicle_matatu_mask_32570.glb",
  "32575": "/assets/bionicle_mahiki_mask_32575.glb",
  "32566": "/assets/bionicle_pakari_mask_32566.glb",
  "32565": "/assets/bionicle_miru_mask_32565.glb",
  "32571": "/assets/bionicle_kaukau_mask_32571.glb",
  "32568": "/assets/bionicle_kakama_mask_32568.glb",
  "32505": "/assets/bionicle_hau_mask_32505.glb",
  "32573": "/assets/bionicle_huna_mask_32573.glb",

  // Animals
  "4493c01pb02": "/assets/horse_4493c01pb02.glb",
  "6086": "/assets/octopus_6086.glb",
  "48812": "/assets/dog_48812.glb",
  "30464": "/assets/dinosaur_baby_30464.glb",
  "30103": "/assets/bat_30103.glb",
  "30115": "/assets/snake_30115.glb",
  "92084": "/assets/owl_92084.glb",
  "80674": "/assets/butterfly_80674.glb",
  "33121": "/assets/crab_33121.glb",
  "30238": "/assets/spider_30238.glb",

  // Circular Bricks
  "4740": "/assets/4740_dish_radar.glb",
  "6014b": "/assets/6014b_wheel11mm.glb",
  "3960": "/assets/3960_dish_4x4.glb",
  "50990b": "/assets/50990b_dish_10x10.glb",
  "2489": "/assets/2489_barrel_2x2x2.glb",
  "30139": "/assets/30139_barrel_4x4x4.glb",
  "6222": "/assets/6222_brick_round_4x4.glb",
  "41531": "/assets/41531.glb",
  "30360": "/assets/30360.glb",
  "4285b": "/assets/4285b.glb",

  // Minifig Hair
  "3901": "/assets/3901.glb",
  "62696": "/assets/62696.glb",
  "53982": "/assets/53982.glb",
  "53981": "/assets/53981.glb",
  "26139": "/assets/26139.glb",
  "42444": "/assets/42444.glb",
  "30410": "/assets/30410.glb",
  "87991": "/assets/87991.glb",
  "13768": "/assets/13768.glb",
  "37784": "/assets/37784.glb",

  // Technic
  "3713": "/assets/3713.glb",
  "3749": "/assets/3749.glb",
  "24316": "/assets/24316.glb",
  "73230": "/assets/73230.glb",
  "3701": "/assets/3701.glb",
  "32174": "/assets/32174.glb",
  "32034": "/assets/32034.glb",
  "3648": "/assets/3648.glb",
  "3736": "/assets/3736.glb",
  "32168": "/assets/32168.glb",

  // Minifig Headgear
  "3898": "/assets/3898.glb",
  "30203": "/assets/30203.glb",
  "30202": "/assets/30203.glb",
  x164: "/assets/x164.glb",
  "3485": "/assets/3485.glb",
  x52: "/assets/x52.glb",
  "2528": "/assets/2528.glb",
  "3624": "/assets/3624.glb",
  "30325": "/assets/30325.glb",
  "30167": "/assets/30167.glb",
  "30381": "/assets/30381.glb",
};

/**
 * Get the model path for a brick ID
 * Returns the path or a fallback default brick path
 */
export const getModelPath = (brickId: string): string => {
  return brickModelPaths[brickId] || brickModelPaths["0"];
};
